import { RouterOutlet } from '@angular/router';
import { Component } from '@angular/core';
import { JobWrapper } from '@shared/components/job-wrapper/job-wrapper';

/** Incapsula la creazione di un nuovo ticket, caricata dal router, dentro un popup sempre visibile e a schermo grande. */
@Component({
  selector: 'ta-new-ticket-wrapper',
  template: `
    <ta-job-wrapper dialogCssClass="size-full lg:h-232 lg:w-186" [visible]="true">
      <router-outlet />
    </ta-job-wrapper>
  `,
  imports: [RouterOutlet, JobWrapper]
})
export class NewTicketWrapper {}
